/*
 * Slider
 */

let swipeIndex = 1;
let slide_click = 0;

const s_nav = document.getElementById("solutions_nav");
const s_nav_items = document.querySelectorAll('#solutions_nav .nav-link');

const s_slider = document.getElementById('solutions_slider');
const s_slides = document.querySelectorAll('#solutions_slider .slider__slide');
const s_slides_wrap = document.getElementById('slides_wrap');

const s_content_items = document.querySelectorAll('.slider__contents .slider__content');

// tab link scroll top of tab-nav
const tab_links = document.querySelectorAll('.tab-scroll-link');
const solutions_nav = document.getElementById("solutions_nav");

if (tab_links) {
	tab_links.forEach((tab_link) => {
		tab_link.addEventListener('click', function () {
			// distance solutions nav from top
			let pos = solutions_nav.offsetTop;
			let distanceTop = pos+50;
			//if (window.pageYOffset < distanceTop) {
				/*document.getElementById('solutions_nav').scrollIntoView({ 
					behavior: 'smooth' 
				});*/
				window.scroll({
				  top: distanceTop, 
				  left: 0, 
				  behavior: 'smooth' 
				});
			//}
		})
	})
}

// javascript
function removeActiveNav() {
	// remove all active
	s_nav_items.forEach((el) => {
    	el.classList.remove("active");
  	})
}

function removeActiveSlide() {
	// remove all active
	s_slides.forEach((el) => {
    	el.classList.remove("active");
  	})
}

function removeActiveContent() {
	// remove all active
	s_content_items.forEach((el) => {
    	el.classList.remove("active");
  	})
}

function resetOverview() {
	// set auto height slide
	slide_click = 0;
	s_slides.forEach((slide) => {
		slide.style.height = "auto";
	});
	// remove active slides and content
	removeActiveSlide();
	removeActiveContent();

	if (s_slider.classList.contains("content-active")) {
		s_slider.classList.remove("content-active");
	}

	s_slides_wrap.style.transform = "translateX(0)";
}

function changeNav(index) {

	var nav_button = document.getElementById("tab-"+index);
	if (nav_button) {
		removeActiveNav();
		// add current active
		nav_button.classList.add("active");
	}
}

function changeSlide(index) {
	index = parseInt(index);
	// is overview?
	if (index > 1) {
		// show content
		// add class to slider wrap
		if (s_slider.classList.contains("content-active") === false) {
			s_slider.classList.add("content-active")
		}
		// add height after second on product click
		if (slide_click === 1 ) {
			s_slides.forEach((slide) => {
				slide.style.height = s_slides_wrap.offsetHeight+"px";
			});
		}
		var s_height = s_slides[0].style.height;
		if (s_height === 'auto') {
			slide_click = 1;
		}

	} else {
		// overview mode
		resetOverview();
	}
	// active content and slide
	var s_slide = document.getElementById("slide-"+index);
	var s_content = document.getElementById("content-"+index);

	if (s_slide) {
		removeActiveSlide();
		// add current active
		s_slide.classList.add("active");
	}

	if (s_content) {
		removeActiveContent();
		// add current active
		s_content.classList.add("active");
	}
	if (index == 2) {
		s_slides_wrap.style.transform = "translateX(15%)";
	}
	if (index > 2) {
		s_slides_wrap.style.transform = "translateX(-15%)";
	}
}

function initSlider() {
	// add click event on nav tabs
	s_nav_items.forEach((nav) => {
		nav.addEventListener('click', function (el) {			
			var n_index = nav.dataset.index;
			changeNav(n_index);
			changeSlide(n_index);
		});
	});

	// add click event on slides
	s_slides.forEach((slide) => {
		slide.addEventListener('click', function (el) {
			el.preventDefault();

			var s_index = slide.dataset.index;
			changeNav(s_index);
			changeSlide(s_index);
		});
	});
}

function updateSlider() {
	//console.log('resize');
}

window.addEventListener("load", function() {
	if (s_slides) {
		initSlider()
	}
})

window.addEventListener("resize", function() {
	if (s_slides) {
    	updateSlider()
    }
})